import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { lazy, Suspense, useEffect } from "react";
import "@fortawesome/fontawesome-free/css/all.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.css";
// import "./assets/css/modal.css";
import "./ali_style.css";
import "./assets/css/responsive.css";

const Login = lazy(() => import("./pages/Login"));
const Registration = lazy(() => import("./pages/registration/Registration"));
const AdminHome = lazy(() => import("./pages/dashboard/AdminHome"));
const AdminProfile = lazy(() => import("./pages/profile/AdminProfile"));
const Logout = lazy(() => import("./pages/Logout"));
const NotFound = lazy(() => import("./components/NotFound"));
const ServiceList = lazy(() => import("./pages/service/ServiceList"));
const Setting = lazy(() => import("./pages/setting/Setting"));
const AreaList = lazy(() => import("./pages/area/AreaList"));
const AddCategoryPage = lazy(() => import("./pages/category/AddCategoryPage"));
const CityList = lazy(() => import("./pages/city/CityList"));
const CityZipList = lazy(() => import("./pages/cityZip/CityZipList"));
const TeamMemberList = lazy(() => import("./pages/teamMember/TeamMemberList"));
const PendingTeamMemberList = lazy(() => import("./pages/teamMember/PendingTeamMemberList"));
const PreApprovedTeamMemberList = lazy(() => import("./pages/teamMember/preApprovedTeamMemberList"));
const ApprovedTeamMemberList = lazy(() => import("./pages/teamMember/ApprovedTeamMemberList"));
const Module = lazy(() => import("./pages/admin/Module"));
const Role = lazy(() => import("./pages/admin/Role"));
const PermissionList = lazy(() => import("./pages/admin/Permission"));
const ServiceAddForm = lazy(() => import("./pages/service/ServiceAddForm"));
const CategoryAddForm = lazy(() => import("./pages/category/CategoryAddForm"));
const FieldsetBuilderList = lazy(() => import("./pages/fieldsetBuilder/FieldsetBuilderList"));
const RndServiceList = lazy(() => import("./pages/service/rnd__ServiceList"));
const OrderListPage = lazy(() => import("./pages/order/OrderListPage"));
const FranchiseMemberList = lazy(() => import("./pages/franchise/FranchiseMemberList"));
const CustomerListPage = lazy(() => import("./pages/customer/CustomerListPage"));
const ItemListConfigPage = lazy(() => import("./pages/setting/ItemListConfigPage"));
const NotificationTemplate = lazy(() => import("./pages/notificationSetting/NotificationTemplate"));
const JointNotificationToStage = lazy(() => import("./pages/notificationSetting/JointNotificationToStage"));
const NotificationCategories = lazy(() => import("./pages/notificationSetting/NotificationCategories"));
const FAQTemplate = lazy(() => import("./pages/faqSetting/FAQTemplate"));
const WorkerDesignation = lazy(() => import("./pages/adminSetting/WorkerDesignation"));
const WorkerRole = lazy(() => import("./pages/adminSetting/WorkerRole"));
const WorkerModule = lazy(() => import("./pages/adminSetting/WorkerModule"));
const WorkerModuleMenuList = lazy(() => import("./pages/adminSetting/WorkerModuleMenuList"));
const WorkerDesignationRole = lazy(() => import("./pages/adminSetting/WorkerDesignationRole"));
const IdentityListPage = lazy(() => import("./pages/serviceIdentity/IdentityListPage"));
const MaterialListPage = lazy(() => import("./pages/materialLibrary/MaterialListPage"));
const InterestedCategories = lazy(() => import("./pages/category/InterestedCategories"));
const InterestedCategoriesAnalytics = lazy(() => import("./pages/category/InterestedCategoriesAnalytics"));
const ServiceItemList = lazy(() => import("./pages/setting/ServiceItemList"));
const AddNewPage = lazy(() => import("./pages/setting/AddNewPage"));
const ServiceItemConfiguration = lazy(() => import("./pages/setting/ServiceItemConfiguration"));
const ProfilePage = lazy(() => import("./pages/teamMember/ProfilePage"));
const ServiceRequestList = lazy(() => import("./pages/ServiceRequest/ServiceRequestList"));
const CategoryRequestList = lazy(() => import("./pages/ServiceRequest/CategoryRequestList"));
const AreaRequestList = lazy(() => import("./pages/ServiceRequest/AreaRequestList"));
const SubItemConfiguration = lazy(() => import("./pages/setting/SubItemConfiguration"));
const OrderDetailsPage = lazy(() => import("./pages/teamMember/OrderDetailsPage"));
const ProfileDetails = lazy(() => import("./pages/teamMember/ProfileDetails"));
const ServiceItemAddForm = lazy(() => import("./pages/setting/ServiceItemAddForm"));
const EditCategoryPage = lazy(() => import("./pages/category/EditCategoryPage"));
const ViewServicePage = lazy(() => import("./pages/service/VeiwServicePage"));
const Notifications = lazy(() => import("./pages/notifications/Notifications"));
const TestingZone = lazy(() => import("./component/area/TestingZone"));
const ShimmerAnimation = lazy(() => import("./pages/shimmerAnimation/ShimmerAnimation"));
const ServiceListByItemPage = lazy(() => import("./pages/area/ServiceListByItemPage"));
const PriceManagement = lazy(() => import("./pages/ServiceRequest/PriceManagement"));
const AreaConfiguration = lazy(() => import("./pages/area/AreaConfiguration"));
const ServiceAreaSample = lazy(() => import("./pages/area/ServiceAreaSample"));
const ServiceViewWithPriceList = lazy(() => import("./pages/teamMember/ServiceViewWithPriceList"));
const TestingFilterComponent = lazy(() => import("./component/testing-filter/TestingFilterComponent"));
const TipsAndRewardsPage = lazy(() => import("./pages/tipsRewards/TipsAndRewardsPage"));
const RatingsListPage = lazy(() => import("./pages/ratings/RatingsListPage"));
const TestingFileDownload = lazy(() => import("./pages/testing/TestingFileDownload"));
const UserProfilePage = lazy(() => import("./pages/customer/UserProfilePage"));
const TestingFCMNotification = lazy(() => import("./pages/testing/TestingFCMNotification"));
const DisputeAndClaim = lazy(() => import("./pages/disputeAndClaim/InvoiceListPage"));
const SupportContent = lazy(() => import("./pages/supportCenter/SupportContent"));
const PageSetting = lazy(() => import("./pages/metaSetting/PageSetting"));
const Websocket = lazy(() => import("./pages/testing/Websocket"));
const DisputeSetting = lazy(() => import("./pages/disputeAndClaim/DisputeSettingPage"));
const ClaimDetailsPage = lazy(() => import("./pages/disputeAndClaim/ClaimDetailsPage"));
const RfqList = lazy(() => import("./pages/rfqList/RfqList"));
const ProviderTeamDetails = lazy(() => import("./pages/teamMember/ProviderTeamDetails"));
const ViewServiceDetailsPage = lazy(() => import("./pages/service/VeiwServiceDetailsPage"));
const EmailManagement = lazy(() => import("./pages/emailManagement/EmailManagement"));

const InitialAppShell = () => (
  <div className="initial-app-shell" aria-hidden="true">
    <div className="initial-app-shell-header">
      <div className="initial-app-shell-brand">Help Abode - Dashboard</div>
      <div className="initial-app-shell-profile">
        <span></span>
        <i></i>
      </div>
    </div>
    <div className="initial-app-shell-sidebar">
      <div className="initial-app-shell-sidebar-title"></div>
      {Array.from({ length: 8 }).map((_, index) => (
        <div className="initial-app-shell-menu" key={index}>
          <span></span>
          <i></i>
        </div>
      ))}
    </div>
    <main className="initial-app-shell-content">
      <div className="initial-app-shell-page-title"></div>
      <div className="initial-app-shell-panel">
        <div className="initial-app-shell-panel-title"></div>
        <div className="initial-app-shell-row"></div>
        <div className="initial-app-shell-row"></div>
        <div className="initial-app-shell-row initial-app-shell-row-short"></div>
      </div>
    </main>
  </div>
);

function App() {
  return (

    <BrowserRouter>
      <Suspense fallback={<InitialAppShell />}>
        <Routes>
        <Route path="" element={<RedirectBasedOnToken />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/dashboard" element={<AdminHome />} />
        <Route path="/profile" element={<AdminProfile />} />
        <Route path="/service-items" element={<ServiceItemList />} />
        {/* <Route path="/service-items/:item" element={<ServiceSubItemListPage />} /> */}
        <Route path="/service-items/:item" element={<ServiceItemAddForm />} />
        <Route path="/service-items/add-item" element={<AddNewPage />} />
        <Route path="/service-items/edit-item/:item" element={<ServiceItemAddForm />} />
        <Route path="/service-items/:item/configuration" element={<ServiceItemConfiguration />} />
        <Route path="/service-items/:item/configuration-sub" element={<SubItemConfiguration />} />
        <Route path="/service-area" element={<AreaList />} />
        <Route path="/service-area/sample" element={<ServiceAreaSample />} />
        <Route path="/service-area/:item" element={<ServiceListByItemPage />} />
        <Route path="/service-area/:item/zone/:id" element={<AreaConfiguration />} />
        <Route path="/service" element={<ServiceList />} />
        <Route path="/service/:item" element={<AddCategoryPage />} />

        <Route path="/service/details/:item" element={<ViewServiceDetailsPage />} />


        <Route path="/service/:item/:categoryId" element={<AddCategoryPage />} />
        <Route path="/service/add-service/:item/:category" element={<ServiceAddForm />} />
        <Route path="/service/:item/:serviceId/view" element={<ViewServicePage />} />
        <Route path="/service/edit-service/:item/:service" element={<ServiceAddForm />} />
        <Route path="/service/add-category/:item/:category" element={<CategoryAddForm />} />
        <Route path="/service/edit-category/:item/:category" element={<EditCategoryPage />} />
        <Route path="/cities" element={<CityList />} />
        <Route path="/cityzip" element={<CityZipList />} />
        <Route path="/servicebuilder" element={<FieldsetBuilderList />} />
        <Route path="/order" element={<OrderListPage />} />
        <Route path="/order/:orderTextId" element={<OrderDetailsPage />} />
        <Route path="/admin" element={<Module />} />
        <Route path="/admin/modules" element={<Module />} />
        <Route path="/admin/roles" element={<Role />} />
        <Route path="/admin/permissions" element={<PermissionList />} />
        <Route path="/provider" element={<TeamMemberList />} />
        <Route path="/provider/provider-list" element={<TeamMemberList />} />
        <Route path="/provider/team-details/:providerTextId" element={<ProviderTeamDetails />} />
        <Route path="/provider/provider-list/:item" element={<ProfilePage />} />
        <Route path="/provider/provider-list/:item/:orderTextId" element={<OrderDetailsPage />} />
        <Route path="/provider/:item/:serviceId" element={<ServiceViewWithPriceList />} />
        <Route path="/provider/test/:item" element={<ProfileDetails />} />
        <Route path="/provider/pending" element={<PendingTeamMemberList />} />
        <Route path="/provider/pre-approve" element={<PreApprovedTeamMemberList />} />
        <Route path="/provider/approved" element={<ApprovedTeamMemberList />} />
        <Route path="/franchise" element={<FranchiseMemberList />} />
        <Route path="/provider/category" element={<CategoryRequestList />} />
        <Route path="/provider/service" element={<ServiceRequestList />} />
        <Route path="/provider/area" element={<AreaRequestList />} />
        <Route path="/enduser-rfq-list" element={<RfqList />} />

        {/*<Route path="/provider/price" element={<PriceRequestList />} />*/}
        <Route path="/provider/manage-price" element={<PriceManagement />} />
        <Route path="/EndUser" element={<CustomerListPage />} />
        <Route path="/EndUser/:user" element={<UserProfilePage />} />
        <Route path="/EndUser/:user/:orderTextId" element={<OrderDetailsPage />} />
        
        {/*================= Notifications===================== */}
        <Route path="/notifications/all-notifications" element={<Notifications />} />
        <Route path="/notifications/notifications-settings" element={<NotificationTemplate />} />
        <Route path="/notifications/category" element={<NotificationCategories />} />
        <Route path="/notifications/notifications-event" element={<JointNotificationToStage />} />
        {/*==============End Notifications===================== */}
        <Route path="/dispute" element={<DisputeAndClaim />} />
        <Route path="/dispute/claim-list" element={<DisputeAndClaim />} />
        <Route path="/dispute/claim-list/:claimTextId" element={<ClaimDetailsPage />} />
        <Route path="/dispute/setting" element={<DisputeSetting />} />
        <Route path="/setting" element={<Setting />} />
        <Route path="/setting/item-config" element={<ItemListConfigPage />} />
        <Route path="/setting/faq" element={<FAQTemplate />} />
        {/* ===================provider module=========================== */}
        <Route path="/provider-access-control/provider-designation" element={<WorkerDesignation />} />
        <Route path="/provider-access-control/provider-role" element={<WorkerRole />} />
        <Route path="/provider-access-control/provider-module" element={<WorkerModule />} />
        <Route path="/provider-access-control/menus" element={<WorkerModuleMenuList />} />
        <Route path="/setting/provider-module/provider-designation-role" element={<WorkerDesignationRole />} />
        <Route path="/setting/meta" element={<PageSetting />} />
        <Route path="/setting/identity" element={<IdentityListPage />} />
        <Route path="/setting/materials" element={<MaterialListPage />} />
        <Route path="/setting/interested-categories" element={<InterestedCategories />} />
        <Route path="/setting/interested-analytics/:categoryId" element={<InterestedCategoriesAnalytics />} />
        <Route path="/setting/stage" element={<JointNotificationToStage />} />
        <Route path="/support" element={<SupportContent />} />
        <Route path="/support/support-home" element={<SupportContent />} />
        <Route path="/email-management/inbox" element={<EmailManagement />} />
        <Route path="/email-management/sent-history" element={<EmailManagement />} />
        <Route path="/tips-rewards" element={<TipsAndRewardsPage />} />
        <Route path="/ratings" element={<RatingsListPage />} />
        <Route path="/rnd" element={<RndServiceList />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/testing-zone" element={<TestingZone />} />
        <Route path="/testing" element={<TestingFCMNotification />} />
        <Route path="/testing/websocket" element={<Websocket />} />
        <Route path="/testing-ShimmerAnimation" element={<ShimmerAnimation />} />
        <Route path="/testing-filter" element={<TestingFilterComponent />} />
        <Route path="/file-download" element={<TestingFileDownload />} />
        {/* git */}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;

function RedirectBasedOnToken() {
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token === "undefined" || token === null) {
      navigate("/login");
    } else {
      navigate("/dashboard");
    }
  }, [navigate]);

  return null; // or any loading component if needed
}

